/* eslint-disable camelcase */
import React from "react"
import { Paper, Typography, Box } from "@mui/material"
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@mui/lab"
import ReceiptIcon from "@mui/icons-material/Receipt"
import TouchAppIcon from "@mui/icons-material/TouchApp"

const TimelineBitacora = ({ historial = [] }) => {
  return (
    <Paper
      elevation={3}
      sx={{ p: 2, borderRadius: 2, height: "100%", maxHeight: "calc(100vh - 220px)", overflowY: "auto" }}
    >
      <Typography variant="subtitle1" fontWeight="bold" color="primary" mb={2}>
        Bitácora y Trazabilidad (Timeline)
      </Typography>

      {historial.length === 0 ? (
        <Typography variant="body2" color="textSecondary" align="center" mt={5}>
          No hay eventos registrados en esta carpeta.
        </Typography>
      ) : (
        <Timeline position="right" sx={{ p: 0, m: 0 }}>
          {historial.map((item, index) => {
            const isAutomaticoERP = !!item.ref_documento

            return (
              <TimelineItem key={item.his_id}>
                <TimelineOppositeContent sx={{ flex: 0.2, pt: 1.5, px: 2 }}>
                  <Typography variant="caption" color="textSecondary" fontWeight="bold">
                    {item.his_fecha_hora?.substring(0, 10)}
                  </Typography>
                  <br />
                  <Typography variant="caption" color="textSecondary">
                    {item.his_fecha_hora?.substring(11, 16)}
                  </Typography>
                </TimelineOppositeContent>

                <TimelineSeparator>
                  <TimelineDot color={isAutomaticoERP ? "warning" : "primary"}>
                    {isAutomaticoERP ? <ReceiptIcon fontSize="small" /> : <TouchAppIcon fontSize="small" />}
                  </TimelineDot>
                  {index < historial.length - 1 && <TimelineConnector />}
                </TimelineSeparator>

                <TimelineContent sx={{ py: 1, px: 2 }}>
                  <Paper
                    elevation={1}
                    sx={{ p: 1.5, bgcolor: isAutomaticoERP ? "#fff8e1" : "#e3f2fd", borderRadius: 2 }}
                  >
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {item.etapa_origen}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Por: {item.usrcodigo}
                      </Typography>
                    </Box>
                    <Typography variant="body2">{item.his_observacion}</Typography>
                    {isAutomaticoERP && (
                      <Typography variant="caption" display="block" color="warning.dark" fontWeight="bold" mt={1}>
                        Ref. Documento: {item.ref_documento}
                      </Typography>
                    )}
                  </Paper>
                </TimelineContent>
              </TimelineItem>
            )
          })}
        </Timeline>
      )}
    </Paper>
  )
}

export default TimelineBitacora
